import { createFileRoute } from '@tanstack/react-router';

import sampleDiff from '@/lib/__tests__/fixtures/sample-diff.txt?raw';
import { parseGitDiff } from '@/lib/diff-parser';

export const Route = createFileRoute('/_authed/_layout/test')({
  component: TestRoute,
});

const files = parseGitDiff(sampleDiff);
const FILE_PATH = 'packages/web/src/lib/filters.ts';

const file = files.find((f) => f.newPath === FILE_PATH);
const hunks = file ? file.hunks : [];

function TestRoute() {
  <div>Test</div>;
}
